import { render, staticRenderFns } from "./TipoReporteVerPage.vue?vue&type=template&id=20bca92e"
import script from "./TipoReporteVerPage.js?vue&type=script&lang=js&external"
export * from "./TipoReporteVerPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports